import React from 'react'
import { toast } from 'react-toastify'
import { Stack } from '@mui/system'
import { Button, Container, Typography, OutlinedInput, InputAdornment } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import { FullScreenLoader, ElxDataTable } from '../../components'

import { useGetClientListQuery, useUpdateClientDetailsMutation } from '../../redux/api/clientApi'
import { ClientDetailForm } from './ClientDetailForm'
import axios from 'axios'

export function ClientPage() {
  const { isLoading, data, refetch } = useGetClientListQuery(null)
  const [updateStatus, { isSuccess, isError, isLoading: loading, error }] =
    useUpdateClientDetailsMutation()
  const [searchKey, setSearchKey] = React.useState<string>('')
  const [dealerGroupNumberList, setDealerGroupNumberList] = React.useState<any>([])
  const getCookie = (cookieName: string): string | null => {
    const name = `${cookieName}=`
    const decodedCookie = decodeURIComponent(document.cookie)
    const cookieArray = decodedCookie.split('; ')

    for (const cookie of cookieArray) {
      if (cookie.startsWith(name)) {
        return cookie.substring(name.length)
      }
    }
    return null
  }

  React.useEffect(() => {
    const fetchDealerGroupData = async () => {
      const opwBaseUrl = `${process.env.REACT_APP_OPW_SERVICE_API_ENDPOINT}/`
      const url = `${opwBaseUrl}dealergroups/get_list/all`
      let token = getCookie('access_tokenn')

      if (!token) {
        token = localStorage.getItem('access_token')
      }

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        setDealerGroupNumberList(response.data.data.dealerGroupList)
      } catch (err: any) {
        console.log(err.message || 'Failed to fetch data')
      }
    }

    fetchDealerGroupData()
  }, [])

  React.useEffect(() => {
    if (isSuccess) {
      toast.success('Success!')
      refetch()
    }
    if (isError) {
      if (Array.isArray((error as any)?.data?.error)) {
        const errors = error as any
        errors?.data.error.forEach((el: any) =>
          toast.error(el?.message ?? 'Something Failed!', {
            position: 'top-right',
          }),
        )
      } else {
        toast.error((error as any)?.data?.message ?? 'Something Failed!', {
          position: 'top-right',
        })
      }
    }
  }, [loading])
  const [isVisible, setIsVisible] = React.useState(false)
  const [editableLeadType, setEditableLeadType] = React.useState()
  const [editableClient, setEditableClient] = React.useState<any>(null)

  if (isLoading || !data || loading) {
    return <FullScreenLoader />
  }

  const handleEditable = (data: any) => {
    setEditableLeadType(data)
    setEditableClient(data)
    setIsVisible(true)
  }

  const handleStatusUpdate = (data: any) => {
    const updatedData = {
      moduleIds: Array.isArray(data.moduleIds)
        ? data.moduleIds.map(String)
        : [String(data.moduleIds)],
      isActiveFlg: data.isActiveFlg === 1,
    }
    updateStatus(updatedData)
  }

  return (
    <Container maxWidth='xl' sx={{ paddingTop: 4, paddingBottom: 8 }}>
      <Stack direction='row' justifyContent='space-between' mb={2} mr={1}>
        <Typography variant='h4' color='#1E90FF'>
          Aftermarket Client Admin
        </Typography>
        <Stack direction='row' alignItems='center'>
          <OutlinedInput
            placeholder='Search'
            onChange={(event) => setSearchKey(event.target.value)}
            endAdornment={
              <InputAdornment position='end'>
                <SearchIcon />
              </InputAdornment>
            }
            sx={{ marginRight: '20px' }}
          />
          <Button
            variant='outlined'
            sx={{ borderRadius: '20px', height: '40px', textDecoration: 'none' }}
            startIcon={<AddIcon />}
            onClick={() => {
              setIsVisible(true)
              setEditableLeadType(undefined)
              setEditableClient(undefined)
            }}
            size='medium'
          >
            Create
          </Button>
        </Stack>
      </Stack>

      <ElxDataTable
        editable={true}
        checkbox={true}
        headLabelForId={'Client'}
        rows={data ?? []}
        searchKey={searchKey}
        editElxData={(data) => handleEditable(data)}
        disableElxData={handleStatusUpdate}
        perPage={5}
        gapPerPage={5}
        refetch={refetch}
      />

      <ClientDetailForm
        open={isVisible}
        onClose={() => setIsVisible(false)}
        client={editableClient}
        refetch={refetch}
        dealerGroupNumberList={dealerGroupNumberList}
      />
    </Container>
  )
}
